module.exports = __webpack_public_path__ + "our-services-mobi-bg.4585c7243bb0ef7e5b0d.svg";


//////////////////
// WEBPACK FOOTER
// C:/unnati/latestWebCode29march/src/assets/images/our-services-mobi-bg.svg
// module id = ../../../../../src/assets/images/our-services-mobi-bg.svg
// module chunks = main